import clsx from "clsx";
import { FC, useEffect } from "react";
import { SCRIPT_ID, SCRIPT_SRC } from "../../constants";
import styles from "./C285_DonationTool_GivingTech.module.scss";

type C285_DonationTool_GivingTechContent = {
  source: string;
  donationIframeTitle?: string;
};

export type Props = {
  content: C285_DonationTool_GivingTechContent;
};

const C285_DonationTool_GivingTech: FC<Props> = ({ content }) => {
  const { source, donationIframeTitle } = content;

  useEffect(() => {
    if (document.getElementById(SCRIPT_ID)) return;

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = SCRIPT_SRC;
    script.async = true;
    document.head.appendChild(script);
  }, []);

  return (
    <div className={clsx("component", styles.C285_DonationTool_GivingTech)}>
      <div
        data-givingtech={source}
        data-givingtech-title={donationIframeTitle}
      />
    </div>
  );
};

export default C285_DonationTool_GivingTech;
